<div class="container-fluid">
    <img class="img-bg" src="assets/BgPersona.jpeg" alt="">
    <div class="row">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
            <div class="card bg-glass centeredDiv">
                <div class="card-body">
                    <div>
                        <h4 class="header-color">Si-Quote Tool</h4>
                        <img src="assets/loginImg.png" class="height-16" alt="SIEMENS India" />
                    </div>
                    <div>
                        <button id="btn_login" mat-raised-button (click)="login()" [disabled]="isLoginInProgress"
                            class="loginButton">Microsoft Entra ID Login</button>
                    </div>
                </div>
                &nbsp;
                @if (isSessionExpired) {
                <div class="card bg-glass-message session-expired-msg" role="alert">{{ 'SESSION_EXPIRED_INACTIVITY' |
                    translate
                    }}</div>
                }
            </div>
        </div>

    </div>
</div>